import { useState } from 'react';
import './checkbox.scss';

function Checkbox({
    id,
    className,
    onChange,
    checked = false,
    disabled = false
} : {
    id: string,
    className?: string,
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void,
    checked?: boolean,
    disabled?: boolean
}) {
    const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(e);
    }

    return (
        <div className={`checkbox ${checked ? 'checked' : ''} ${disabled ? 'disabled' : ''}`}>
            <input 
                type="checkbox" 
                checked={checked} 
                className={className} 
                id={id} 
                onChange={handleOnChange} 
                disabled={disabled}
            />
        </div>
    )
}

export default Checkbox;